// Clears a saved delivery slot that is no longer valid, on every page except the cart (cart.js handles that one).
(function () {
  const A = window.MiyabiAvailability;
  if (!A || document.querySelector('cart-items')) return;
  const root = window.Shopify?.routes?.root || '/';
  const check = async () => {
    try {
      const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      const date = cart.attributes?.['collection-date'], time = cart.attributes?.['collection-time'];
      if (!date && !time) return;
      await A.sync();
      const html = await (await fetch(root + 'cart?section_id=main-cart-items&_guard=' + Date.now(), { cache: 'no-store' })).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
      const rules = fresh ? [...fresh.querySelectorAll('[data-availability-rule]')].map(el => JSON.parse(el.dataset.availabilityRule)) : [];
      if (!rules.length) return;
      const slots = A.slots(rules, A.parseDisplay(date), A.blocks(fresh.dataset.blockedDates));
      if (slots.some(s => s.label === time)) return;
      await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'collection-date': '', 'collection-time': '' } })
      });
    } catch (error) {}
  };
  check();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
})();
